import Button from "../../../../Components/Common/Button/Button";
import PreconAuthIcon from "../../../../Assets/Img/PreconAuthIcon";
import StepTick from "Assets/Img/StepTick";
import NextIcon from "Assets/Img/NextIcon";
import useScrollToTop from "hooks/useScrollToTop";

const fmtMoney = (
  amount: string | number | null | undefined,
): string | null => {
  if (amount == null || amount === "") return null;
  const num = Number(String(amount).replace(/[$,]/g, ""));
  return isNaN(num) ? null : `$${num.toLocaleString()}`;
};

interface DeliveryRow {
  label: string;
}

interface SuccessScreenProps {
  onViewProject: () => void;
  onDownload: () => void;
  onRestart: () => void;
  projectName?: string;
  bankName?: string;
  ownerName?: string;
  gcName?: string;
  deliverTo?: string;
  deliveryCC?: string[];
  invoiceNumber?: string;
  invoiceAmount?: string | number;
}

const SuccessScreen = ({
  onViewProject,
  onDownload,
  onRestart,
  projectName,
  bankName,
  ownerName,
  gcName,
  deliverTo,
  deliveryCC,
  invoiceNumber,
  invoiceAmount,
}: SuccessScreenProps) => {
  useScrollToTop("success", { skipFirstRender: false });
  const displayProject = projectName || "this project";
  const displayBank = bankName || "the bank";
  const formattedAmount = fmtMoney(invoiceAmount);

  const deliveryRows: DeliveryRow[] = [
    deliverTo ? { label: deliverTo } : null,
    ownerName ? { label: `${ownerName} — Owner Portal` } : null,
    gcName ? { label: `${gcName} — GC Portal` } : null,
    deliveryCC?.length ? { label: `${deliveryCC.join(", ")} — CC` } : null,
    invoiceNumber || formattedAmount
      ? {
          label: [
            "CSC Invoice",
            invoiceNumber
              ? invoiceNumber.startsWith("#")
                ? invoiceNumber
                : `#${invoiceNumber}`
              : null,
            formattedAmount,
            "generated and attached",
          ]
            .filter(Boolean)
            .join(" — "),
        }
      : null,
  ].filter((row): row is DeliveryRow => row !== null);

  return (
    <div className="successWrap">
      <div className="successIcon">
        <PreconAuthIcon />
      </div>
      <div className="successTitle">Pre-Construction Report Published</div>
      <div className="successSub">
        The pre-construction review for {displayProject} has been published and
        delivered to {displayBank}. The report is now locked and visible to all
        authorized parties.
      </div>

      <div className="deliveryCard">
        <div className="deliveryTitle">Delivered To</div>
        {deliveryRows.map((row, i) => (
          <div className="deliveryItem" key={i}>
            <span className="deliveryCheck">
              <StepTick />
            </span>
            {row.label}
          </div>
        ))}
        <div className="deliveryItem">
          <span className="deliveryCheck">
            <StepTick />
          </span>
          First draw disbursement authorization: pending bank approval of this
          report
        </div>
      </div>

      <div className="btnRow center">
        <Button className="btn btnPrimary" onClick={onViewProject}>
          View Project <NextIcon />
        </Button>
        <Button className="btn btnSecondary" onClick={onDownload}>
          Download PDF
        </Button>
        <Button className="btn btnSecondary" onClick={onRestart}>
          Author Another Report
        </Button>
      </div>
    </div>
  );
};

export default SuccessScreen;
